import React from 'react';

import ViewEmailModal from 'components/ViewEmailModal';

import { getTouchDisplayName, showAPIErrorAlert } from 'utils/lib';
import { type EmailTouchPreviewData, loadTouchPreviewData } from 'utils/touch-preview';

interface Props {
  onClose: () => void;
  touchTrigger: any;
  initialPreviewData?: EmailTouchPreviewData | null;
}

const PreviewEmailModal = ({ onClose, touchTrigger, initialPreviewData = null }: Props) => {
  const touchName = getTouchDisplayName(touchTrigger);

  const [emailData, setEmailData] = React.useState<{ subject: string; html: string; } | null>(initialPreviewData
    ? {
      subject: initialPreviewData.subject,
      html: initialPreviewData.html,
    }
    : null);

  React.useEffect(() => {
    if (initialPreviewData) return;

    (async () => {
      try {
        const data = await loadTouchPreviewData(touchTrigger) as EmailTouchPreviewData;

        setEmailData({
          subject: data.subject,
          html: data.html,
        });
      } catch (err) {
        console.error('error', err);
        showAPIErrorAlert(err);
      }
    })();
  }, [initialPreviewData, touchTrigger]);

  return (
    <ViewEmailModal
      title={`${touchName} Preview`}
      emailSubject={emailData?.subject}
      emailHtml={emailData?.html}
      onClose={onClose}
    />
  );
};

export default PreviewEmailModal;
